export const FoldersData = [
  {
    id: 1,
    title: "Technician Reports – Diagnosticsand Repair History",
    name: "Technician Reports – Diagnosticsand Repair History",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "5 folders",
    folder_uuid: "folder-uuid-1",
    internal_name: "tech_reports_diagnostics",
    path: "/shared/tech_reports_diagnostics",
    is_active: true,
    created_at: "2025-09-15T10:00:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 2,
    title: "Manufacturer Submissions – Ford & GM Warranty Claims",
    name: "Manufacturer Submissions – Ford & GM Warranty Claims",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    lastUpdatedTooltip: "24 hours ago",
    folderCount: "3 folders",
    folder_uuid: "folder-uuid-2",
    internal_name: "manufacturer_submissions",
    path: "/shared/manufacturer_submissions",
    is_active: true,
    created_at: "2025-09-20T14:30:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 3,
    title: "Customer Evidence – Consent Formsand Media Uploads",
    name: "Customer Evidence – Consent Formsand Media Uploads",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "8 folders",
    folder_uuid: "folder-uuid-3",
    internal_name: "customer_evidence",
    path: "/shared/customer_evidence",
    is_active: true,
    created_at: "2025-09-18T09:15:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 4,
    title: "Finance Reconciliation – Pending OEM Credits (Q3 2025)",
    name: "Finance Reconciliation – Pending OEM Credits (Q3 2025)",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "5 folders",
    folder_uuid: "folder-uuid-4",
    internal_name: "finance_reconciliation",
    path: "/shared/finance_reconciliation",
    is_active: true,
    created_at: "2025-09-25T11:45:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 5,
    title: "Technician Reports – Diagnosticsand Repair History",
    name: "Technician Reports – Diagnosticsand Repair History",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "5 folders",
    folder_uuid: "folder-uuid-5",
    internal_name: "tech_reports_diagnostics_2",
    path: "/shared/tech_reports_diagnostics_2",
    is_active: true,
    created_at: "2025-09-16T13:20:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 6,
    title: "Manufacturer Submissions – Ford & GM Warranty Claims",
    name: "Manufacturer Submissions – Ford & GM Warranty Claims",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "3 folders",
    folder_uuid: "folder-uuid-6",
    internal_name: "manufacturer_submissions_2",
    path: "/shared/manufacturer_submissions_2",
    is_active: true,
    created_at: "2025-09-21T16:10:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 7,
    title: "Customer Evidence – Consent Formsand Media Uploads",
    name: "Customer Evidence – Consent Formsand Media Uploads",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "8 folders",
    folder_uuid: "folder-uuid-7",
    internal_name: "customer_evidence_2",
    path: "/shared/customer_evidence_2",
    is_active: true,
    created_at: "2025-09-19T12:30:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 8,
    title: "Warranty Claims Processing – Q4 2025",
    name: "Warranty Claims Processing – Q4 2025",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "12 folders",
    folder_uuid: "folder-uuid-8",
    internal_name: "warranty_claims_processing",
    path: "/shared/warranty_claims_processing",
    is_active: true,
    created_at: "2025-09-22T08:45:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 9,
    title: "Engine Diagnostics – Ford F-150 Series",
    name: "Engine Diagnostics – Ford F-150 Series",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "7 folders",
    folder_uuid: "folder-uuid-9",
    internal_name: "engine_diagnostics_ford",
    path: "/shared/engine_diagnostics_ford",
    is_active: true,
    created_at: "2025-09-17T15:20:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 10,
    title: "Transmission Reports – GM Silverado",
    name: "Transmission Reports – GM Silverado",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "4 folders",
    folder_uuid: "folder-uuid-10",
    internal_name: "transmission_reports_gm",
    path: "/shared/transmission_reports_gm",
    is_active: true,
    created_at: "2025-09-23T10:15:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 11,
    title: "Customer Service Records – 2025",
    name: "Customer Service Records – 2025",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "15 folders",
    folder_uuid: "folder-uuid-11",
    internal_name: "customer_service_records",
    path: "/shared/customer_service_records",
    is_active: true,
    created_at: "2025-09-14T14:40:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 12,
    title: "Parts Inventory – Critical Components",
    name: "Parts Inventory – Critical Components",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "6 folders",
    folder_uuid: "folder-uuid-12",
    internal_name: "parts_inventory_critical",
    path: "/shared/parts_inventory_critical",
    is_active: true,
    created_at: "2025-09-24T11:25:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 13,
    title: "Quality Assurance – Final Inspections",
    name: "Quality Assurance – Final Inspections",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "9 folders",
    folder_uuid: "folder-uuid-13",
    internal_name: "quality_assurance_inspections",
    path: "/shared/quality_assurance_inspections",
    is_active: true,
    created_at: "2025-09-26T13:50:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 14,
    title: "Safety Protocols – Workshop Procedures",
    name: "Safety Protocols – Workshop Procedures",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "3 folders",
    folder_uuid: "folder-uuid-14",
    internal_name: "safety_protocols_workshop",
    path: "/shared/safety_protocols_workshop",
    is_active: true,
    created_at: "2025-09-27T09:30:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 15,
    title: "Training Materials – New Technician Onboarding",
    name: "Training Materials – New Technician Onboarding",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "11 folders",
    folder_uuid: "folder-uuid-15",
    internal_name: "training_materials_onboarding",
    path: "/shared/training_materials_onboarding",
    is_active: true,
    created_at: "2025-09-28T16:15:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 16,
    title: "Compliance Documentation – EPA Standards",
    name: "Compliance Documentation – EPA Standards",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "8 folders",
    folder_uuid: "folder-uuid-16",
    internal_name: "compliance_documentation_epa",
    path: "/shared/compliance_documentation_epa",
    is_active: true,
    created_at: "2025-09-29T12:00:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 17,
    title: "Equipment Maintenance – Diagnostic Tools",
    name: "Equipment Maintenance – Diagnostic Tools",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "5 folders",
    folder_uuid: "folder-uuid-17",
    internal_name: "equipment_maintenance_tools",
    path: "/shared/equipment_maintenance_tools",
    is_active: true,
    created_at: "2025-09-30T14:45:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 18,
    title: "Vendor Communications – Parts Suppliers",
    name: "Vendor Communications – Parts Suppliers",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "7 folders",
    folder_uuid: "folder-uuid-18",
    internal_name: "vendor_communications_suppliers",
    path: "/shared/vendor_communications_suppliers",
    is_active: true,
    created_at: "2025-10-01T10:20:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 19,
    title: "Insurance Claims – Vehicle Damage Reports",
    name: "Insurance Claims – Vehicle Damage Reports",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "4 folders",
    folder_uuid: "folder-uuid-19",
    internal_name: "insurance_claims_damage",
    path: "/shared/insurance_claims_damage",
    is_active: true,
    created_at: "2025-10-01T08:35:00Z",
    parent_folder_uuid: null,
  },
  {
    id: 20,
    title: "Environmental Reports – Waste Disposal",
    name: "Environmental Reports – Waste Disposal",
    lastUpdated: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    folderCount: "2 folders",
    folder_uuid: "folder-uuid-20",
    internal_name: "environmental_reports_waste",
    path: "/shared/environmental_reports_waste",
    is_active: true,
    created_at: "2025-10-01T06:10:00Z",
    parent_folder_uuid: null,
  },
];
export const drivesData = [
  {
    id: 1,
    title: "My Workspace",
    lastUpdated: "2025-10-01T15:00:00Z",
    lastUpdatedTooltip: "Just now",
    folderCount: "5 folders",
  },
  {
    id: 2,
    title: "Team Drive",
    lastUpdated: "2025-10-01T15:00:00Z",
    folderCount: "3 folders",
  },
  {
    id: 3,
    title: "Project Files",
    lastUpdated: "2025-10-01T15:00:00Z",
    folderCount: "8 folders",
  },
  {
    id: 5,
    title: "My Workspace",
    lastUpdated: "2025-10-01T15:00:00Z",
    lastUpdatedTooltip: "Just now",
    folderCount: "5 folders",
  },
  {
    id: 6,
    title: "Team Drive",
    lastUpdated: "2025-10-01T15:00:00Z",
    folderCount: "3 folders",
  },
  {
    id: 7,
    title: "Project Files",
    icon: "hardDrive2",
    lastUpdated: "2025-10-01T15:00:00Z",
    folderCount: "8 folders",
  },
  {
    id: 8,
    title: "My Workspace",
    icon: "hardDrive2",
    lastUpdated: "2025-10-01T15:00:00Z",
    folderCount: "5 folders",
  },
  {
    id: 9,
    title: "Team Drive",
    icon: "hardDrive2",
    lastUpdated: "2025-10-01T15:00:00Z",
    folderCount: "3 folders",
  },
];

export const documentsData = [
  // loading state - moved to first position for demo
  {
    id: 7,
    title: "Claim# 10498 – Cylinder Head Failure – F-150 3.5L EcoBoost",
    name: "Claim# 10498 – Cylinder Head Failure – F-150 3.5L EcoBoost",
    owner: "John Smith",
    owner_full_name: "John Smith",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    isUploading: true,
    uploadProgress: { current: 5, total: 10 },
    status: undefined,
    tags: [],
    document_uuid: "doc-uuid-7",
    description: "Detailed report on cylinder head failure",
    version: 1,
    scope: "internal",
    summary: "F-150 3.5L EcoBoost cylinder head failure analysis",
    path: "/shared/claims/cylinder_head_failure",
    owner_uuid: "user-uuid-john-smith",
  },
  {
    id: 1,
    title: "OEM Submission – Ford Portal Export – Claim #10231",
    name: "OEM Submission – Ford Portal Export – Claim #10231",
    folderCount: "5 folders",
    owner: "Jhon Smith",
    owner_full_name: "Jhon Smith",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Connected Agent",
    tags: [
      "Product team",
      "Guidelines",
      "Report",
      "Research",
      "Analysis",
      "Review",
      "Final",
    ],
    document_uuid: "doc-uuid-1",
    description: "OEM submission for Ford portal export",
    version: 1,
    scope: "external",
    summary: "Ford portal export claim submission",
    path: "/shared/oem_submissions/ford_portal_export",
    owner_uuid: "user-uuid-jhon-smith",
  },
  {
    id: 2,
    title: "Claim# 10498 - Cylinder Head Failure - F-150 3.5L EcoBoost",
    name: "Claim# 10498 - Cylinder Head Failure - F-150 3.5L EcoBoost",
    folderCount: "3 folders",
    owner: "Sarah Johnson",
    owner_full_name: "Sarah Johnson",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Not Connected",
    tags: ["Warranty", "Engine", "Ford"],
    document_uuid: "doc-uuid-2",
    description: "Cylinder head failure claim documentation",
    version: 1,
    scope: "internal",
    summary: "F-150 3.5L EcoBoost cylinder head failure claim",
    path: "/shared/claims/cylinder_head_failure_claim",
    owner_uuid: "user-uuid-sarah-johnson",
  },
  {
    id: 3,
    title: "Customer Consent Form - Video Inspection - VIN 1FTFW1ED3NFB0...",
    name: "Customer Consent Form - Video Inspection - VIN 1FTFW1ED3NFB0...",
    folderCount: "4 folders",
    owner: "Mike Davis",
    owner_full_name: "Mike Davis",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Connected Agent",
    tags: ["Consent", "Video", "Inspection"],
    document_uuid: "doc-uuid-3",
    description: "Customer consent form for video inspection",
    version: 1,
    scope: "customer",
    summary: "Video inspection consent form for VIN 1FTFW1ED3NFB0",
    path: "/shared/consent_forms/video_inspection_consent",
    owner_uuid: "user-uuid-mike-davis",
  },
  {
    id: 4,
    title: "Warranty Credit Memo - Transmission Failure - $1,820.40",
    name: "Warranty Credit Memo - Transmission Failure - $1,820.40",
    folderCount: "2 folders",
    owner: "Lisa Wilson",
    owner_full_name: "Lisa Wilson",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Expired",
    tags: ["Credit", "Transmission", "Warranty"],
    document_uuid: "doc-uuid-4",
    description: "Warranty credit memo for transmission failure",
    version: 1,
    scope: "financial",
    summary: "Transmission failure warranty credit memo - $1,820.40",
    path: "/shared/warranty_credits/transmission_failure_credit",
    owner_uuid: "user-uuid-lisa-wilson",
  },
  {
    id: 5,
    title: "Warranty Credit Memo - Transmission Failure - $1,820.40",
    name: "Warranty Credit Memo - Transmission Failure - $1,820.40",
    folderCount: "2 folders",
    owner: "Tom Anderson",
    owner_full_name: "Tom Anderson",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Syncing",
    tags: ["Credit", "Transmission", "Warranty", "Ford"],
    document_uuid: "doc-uuid-5",
    description: "Warranty credit memo for transmission failure - Ford",
    version: 1,
    scope: "financial",
    summary: "Ford transmission failure warranty credit memo - $1,820.40",
    path: "/shared/warranty_credits/ford_transmission_failure",
    owner_uuid: "user-uuid-tom-anderson",
  },
  {
    id: 6,
    title:
      "Engine Diagnostic Report - F-150 2.7L EcoBoost - VIN 1FTFW1ET5DFC...",
    name: "Engine Diagnostic Report - F-150 2.7L EcoBoost - VIN 1FTFW1ET5DFC...",
    folderCount: "2 folders",
    owner: "Emma Thompson",
    owner_full_name: "Emma Thompson",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Expiring",
    tags: ["Diagnostic", "Engine", "Ford", "EcoBoost"],
    document_uuid: "doc-uuid-6",
    description: "Engine diagnostic report for F-150 2.7L EcoBoost",
    version: 1,
    scope: "technical",
    summary: "F-150 2.7L EcoBoost engine diagnostic report",
    path: "/shared/diagnostic_reports/f150_ecoboost_engine",
    owner_uuid: "user-uuid-emma-thompson",
  },
  {
    id: 8,
    title: "Brake System Analysis - Silverado 1500 - VIN 1GCVKREC8LZ1...",
    name: "Brake System Analysis - Silverado 1500 - VIN 1GCVKREC8LZ1...",
    owner: "David Brown",
    owner_full_name: "David Brown",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Connected Agent",
    tags: ["Brake", "Analysis", "GM", "Silverado"],
    document_uuid: "doc-uuid-8",
    description: "Brake system analysis for Silverado 1500",
    version: 1,
    scope: "technical",
    summary: "Silverado 1500 brake system analysis report",
    path: "/shared/brake_analysis/silverado_1500_brake",
    owner_uuid: "user-uuid-david-brown",
  },
  {
    id: 9,
    title:
      "Electrical System Diagnostic - F-150 Lightning - VIN 1FT6W1EV5NWA...",
    name: "Electrical System Diagnostic - F-150 Lightning - VIN 1FT6W1EV5NWA...",
    owner: "Jennifer Lee",
    owner_full_name: "Jennifer Lee",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Not Connected",
    tags: ["Electrical", "Lightning", "Ford", "EV"],
    document_uuid: "doc-uuid-9",
    description: "Electrical system diagnostic for F-150 Lightning",
    version: 1,
    scope: "technical",
    summary: "F-150 Lightning electrical system diagnostic",
    path: "/shared/electrical_diagnostics/f150_lightning",
    owner_uuid: "user-uuid-jennifer-lee",
  },
  {
    id: 10,
    title: "Suspension Repair Report - Ram 1500 - VIN 1C6RR7GT5HS1...",
    name: "Suspension Repair Report - Ram 1500 - VIN 1C6RR7GT5HS1...",
    owner: "Michael Chen",
    owner_full_name: "Michael Chen",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Syncing",
    tags: ["Suspension", "Repair", "Ram", "Dodge"],
    document_uuid: "doc-uuid-10",
    description: "Suspension repair report for Ram 1500",
    version: 1,
    scope: "repair",
    summary: "Ram 1500 suspension repair report",
    path: "/shared/repair_reports/ram_1500_suspension",
    owner_uuid: "user-uuid-michael-chen",
  },
  {
    id: 11,
    title: "Engine Oil Analysis - F-150 5.0L V8 - VIN 1FTFW1ET5DFC...",
    name: "Engine Oil Analysis - F-150 5.0L V8 - VIN 1FTFW1ET5DFC...",
    owner: "Amanda Rodriguez",
    owner_full_name: "Amanda Rodriguez",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Connected Agent",
    tags: ["Oil", "Analysis", "Ford", "V8"],
    document_uuid: "doc-uuid-11",
    description: "Engine oil analysis for F-150 5.0L V8",
    version: 1,
    scope: "analysis",
    summary: "F-150 5.0L V8 engine oil analysis",
    path: "/shared/oil_analysis/f150_v8_engine_oil",
    owner_uuid: "user-uuid-amanda-rodriguez",
  },
  {
    id: 12,
    title: "Transmission Fluid Report - Silverado 2500HD - VIN 1GCVKREC8LZ1...",
    name: "Transmission Fluid Report - Silverado 2500HD - VIN 1GCVKREC8LZ1...",
    owner: "Robert Taylor",
    owner_full_name: "Robert Taylor",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Expired",
    tags: ["Transmission", "Fluid", "GM", "Heavy Duty"],
    document_uuid: "doc-uuid-12",
    description: "Transmission fluid report for Silverado 2500HD",
    version: 1,
    scope: "maintenance",
    summary: "Silverado 2500HD transmission fluid report",
    path: "/shared/fluid_reports/silverado_2500hd_transmission",
    owner_uuid: "user-uuid-robert-taylor",
  },
  {
    id: 13,
    title:
      "Cooling System Inspection - F-150 3.5L EcoBoost - VIN 1FTFW1ET5DFC...",
    name: "Cooling System Inspection - F-150 3.5L EcoBoost - VIN 1FTFW1ET5DFC...",
    owner: "Maria Garcia",
    owner_full_name: "Maria Garcia",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Expiring",
    tags: ["Cooling", "Inspection", "Ford", "EcoBoost"],
    document_uuid: "doc-uuid-13",
    description: "Cooling system inspection for F-150 3.5L EcoBoost",
    version: 1,
    scope: "inspection",
    summary: "F-150 3.5L EcoBoost cooling system inspection",
    path: "/shared/inspections/f150_ecoboost_cooling",
    owner_uuid: "user-uuid-maria-garcia",
  },
  {
    id: 14,
    title: "Fuel System Diagnostic - Silverado 1500 - VIN 1GCVKREC8LZ1...",
    name: "Fuel System Diagnostic - Silverado 1500 - VIN 1GCVKREC8LZ1...",
    owner: "James Wilson",
    owner_full_name: "James Wilson",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Connected Agent",
    tags: ["Fuel", "Diagnostic", "GM", "Silverado"],
    document_uuid: "doc-uuid-14",
    description: "Fuel system diagnostic for Silverado 1500",
    version: 1,
    scope: "diagnostic",
    summary: "Silverado 1500 fuel system diagnostic",
    path: "/shared/fuel_diagnostics/silverado_1500_fuel",
    owner_uuid: "user-uuid-james-wilson",
  },
  {
    id: 15,
    title: "Exhaust System Repair - F-150 2.7L EcoBoost - VIN 1FTFW1ET5DFC...",
    name: "Exhaust System Repair - F-150 2.7L EcoBoost - VIN 1FTFW1ET5DFC...",
    owner: "Patricia Martinez",
    owner_full_name: "Patricia Martinez",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Not Connected",
    tags: ["Exhaust", "Repair", "Ford", "EcoBoost"],
    document_uuid: "doc-uuid-15",
    description: "Exhaust system repair for F-150 2.7L EcoBoost",
    version: 1,
    scope: "repair",
    summary: "F-150 2.7L EcoBoost exhaust system repair",
    path: "/shared/exhaust_repairs/f150_ecoboost_exhaust",
    owner_uuid: "user-uuid-patricia-martinez",
  },
  {
    id: 16,
    title: "Steering System Analysis - Ram 2500 - VIN 1C6RR7GT5HS1...",
    name: "Steering System Analysis - Ram 2500 - VIN 1C6RR7GT5HS1...",
    owner: "Christopher Davis",
    owner_full_name: "Christopher Davis",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Syncing",
    tags: ["Steering", "Analysis", "Ram", "Heavy Duty"],
    document_uuid: "doc-uuid-16",
    description: "Steering system analysis for Ram 2500",
    version: 1,
    scope: "analysis",
    summary: "Ram 2500 steering system analysis",
    path: "/shared/steering_analysis/ram_2500_steering",
    owner_uuid: "user-uuid-christopher-davis",
  },
  {
    id: 17,
    title: "Battery Performance Test - F-150 Lightning - VIN 1FT6W1EV5NWA...",
    name: "Battery Performance Test - F-150 Lightning - VIN 1FT6W1EV5NWA...",
    owner: "Michelle Johnson",
    owner_full_name: "Michelle Johnson",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Connected Agent",
    tags: ["Battery", "Performance", "Ford", "Lightning"],
    document_uuid: "doc-uuid-17",
    description: "Battery performance test for F-150 Lightning",
    version: 1,
    scope: "performance",
    summary: "F-150 Lightning battery performance test",
    path: "/shared/battery_tests/f150_lightning_battery",
    owner_uuid: "user-uuid-michelle-johnson",
  },
  {
    id: 18,
    title: "Tire Wear Analysis - Silverado 1500 - VIN 1GCVKREC8LZ1...",
    name: "Tire Wear Analysis - Silverado 1500 - VIN 1GCVKREC8LZ1...",
    owner: "Daniel Anderson",
    owner_full_name: "Daniel Anderson",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Expired",
    tags: ["Tire", "Wear", "GM", "Silverado"],
    document_uuid: "doc-uuid-18",
    description: "Tire wear analysis for Silverado 1500",
    version: 1,
    scope: "analysis",
    summary: "Silverado 1500 tire wear analysis",
    path: "/shared/tire_analysis/silverado_1500_tire_wear",
    owner_uuid: "user-uuid-daniel-anderson",
  },
  {
    id: 19,
    title:
      "Climate Control Diagnostic - F-150 3.5L EcoBoost - VIN 1FTFW1ET5DFC...",
    name: "Climate Control Diagnostic - F-150 3.5L EcoBoost - VIN 1FTFW1ET5DFC...",
    owner: "Laura Thompson",
    owner_full_name: "Laura Thompson",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Expiring",
    tags: ["Climate", "Control", "Ford", "EcoBoost"],
    document_uuid: "doc-uuid-19",
    description: "Climate control diagnostic for F-150 3.5L EcoBoost",
    version: 1,
    scope: "diagnostic",
    summary: "F-150 3.5L EcoBoost climate control diagnostic",
    path: "/shared/climate_diagnostics/f150_ecoboost_climate",
    owner_uuid: "user-uuid-laura-thompson",
  },
  {
    id: 20,
    title: "Safety System Check - Ram 1500 - VIN 1C6RR7GT5HS1...",
    name: "Safety System Check - Ram 1500 - VIN 1C6RR7GT5HS1...",
    owner: "Kevin White",
    owner_full_name: "Kevin White",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Connected Agent",
    tags: ["Safety", "Check", "Ram", "Dodge"],
    document_uuid: "doc-uuid-20",
    description: "Safety system check for Ram 1500",
    version: 1,
    scope: "safety",
    summary: "Ram 1500 safety system check",
    path: "/shared/safety_checks/ram_1500_safety",
    owner_uuid: "user-uuid-kevin-white",
  },
  {
    id: 21,
    title: "Engine Mount Inspection - F-150 5.0L V8 - VIN 1FTFW1ET5DFC...",
    name: "Engine Mount Inspection - F-150 5.0L V8 - VIN 1FTFW1ET5DFC...",
    owner: "Nicole Brown",
    owner_full_name: "Nicole Brown",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Not Connected",
    tags: ["Engine", "Mount", "Ford", "V8"],
    document_uuid: "doc-uuid-21",
    description: "Engine mount inspection for F-150 5.0L V8",
    version: 1,
    scope: "inspection",
    summary: "F-150 5.0L V8 engine mount inspection",
    path: "/shared/mount_inspections/f150_v8_engine_mount",
    owner_uuid: "user-uuid-nicole-brown",
  },
  {
    id: 22,
    title:
      "Differential Service Report - Silverado 2500HD - VIN 1GCVKREC8LZ1...",
    name: "Differential Service Report - Silverado 2500HD - VIN 1GCVKREC8LZ1...",
    owner: "Steven Miller",
    owner_full_name: "Steven Miller",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Syncing",
    tags: ["Differential", "Service", "GM", "Heavy Duty"],
    document_uuid: "doc-uuid-22",
    description: "Differential service report for Silverado 2500HD",
    version: 1,
    scope: "service",
    summary: "Silverado 2500HD differential service report",
    path: "/shared/service_reports/silverado_2500hd_differential",
    owner_uuid: "user-uuid-steven-miller",
  },
  {
    id: 23,
    title: "Turbocharger Analysis - F-150 3.5L EcoBoost - VIN 1FTFW1ET5DFC...",
    name: "Turbocharger Analysis - F-150 3.5L EcoBoost - VIN 1FTFW1ET5DFC...",
    owner: "Rachel Green",
    owner_full_name: "Rachel Green",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Connected Agent",
    tags: ["Turbocharger", "Analysis", "Ford", "EcoBoost"],
    document_uuid: "doc-uuid-23",
    description: "Turbocharger analysis for F-150 3.5L EcoBoost",
    version: 1,
    scope: "analysis",
    summary: "F-150 3.5L EcoBoost turbocharger analysis",
    path: "/shared/turbo_analysis/f150_ecoboost_turbo",
    owner_uuid: "user-uuid-rachel-green",
  },
  {
    id: 24,
    title: "Hydraulic System Check - Ram 3500 - VIN 1C6RR7GT5HS1...",
    name: "Hydraulic System Check - Ram 3500 - VIN 1C6RR7GT5HS1...",
    owner: "Mark Thompson",
    owner_full_name: "Mark Thompson",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Expired",
    tags: ["Hydraulic", "Check", "Ram", "Heavy Duty"],
    document_uuid: "doc-uuid-24",
    description: "Hydraulic system check for Ram 3500",
    version: 1,
    scope: "check",
    summary: "Ram 3500 hydraulic system check",
    path: "/shared/hydraulic_checks/ram_3500_hydraulic",
    owner_uuid: "user-uuid-mark-thompson",
  },
  {
    id: 25,
    title: "Emission System Test - F-150 2.7L EcoBoost - VIN 1FTFW1ET5DFC...",
    name: "Emission System Test - F-150 2.7L EcoBoost - VIN 1FTFW1ET5DFC...",
    owner: "Sandra Clark",
    owner_full_name: "Sandra Clark",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Expiring",
    tags: ["Emission", "Test", "Ford", "EcoBoost"],
    document_uuid: "doc-uuid-25",
    description: "Emission system test for F-150 2.7L EcoBoost",
    version: 1,
    scope: "test",
    summary: "F-150 2.7L EcoBoost emission system test",
    path: "/shared/emission_tests/f150_ecoboost_emission",
    owner_uuid: "user-uuid-sandra-clark",
  },
  {
    id: 26,
    title: "Power Steering Fluid - Silverado 1500 - VIN 1GCVKREC8LZ1...",
    name: "Power Steering Fluid - Silverado 1500 - VIN 1GCVKREC8LZ1...",
    owner: "Brian Lewis",
    owner_full_name: "Brian Lewis",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Connected Agent",
    tags: ["Power Steering", "Fluid", "GM", "Silverado"],
    document_uuid: "doc-uuid-26",
    description: "Power steering fluid report for Silverado 1500",
    version: 1,
    scope: "maintenance",
    summary: "Silverado 1500 power steering fluid report",
    path: "/shared/power_steering/silverado_1500_fluid",
    owner_uuid: "user-uuid-brian-lewis",
  },
  {
    id: 27,
    title:
      "Air Conditioning Service - F-150 3.5L EcoBoost - VIN 1FTFW1ET5DFC...",
    name: "Air Conditioning Service - F-150 3.5L EcoBoost - VIN 1FTFW1ET5DFC...",
    owner: "Angela Walker",
    owner_full_name: "Angela Walker",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Not Connected",
    tags: ["AC", "Service", "Ford", "EcoBoost"],
    document_uuid: "doc-uuid-27",
    description: "Air conditioning service for F-150 3.5L EcoBoost",
    version: 1,
    scope: "service",
    summary: "F-150 3.5L EcoBoost air conditioning service",
    path: "/shared/ac_service/f150_ecoboost_ac",
    owner_uuid: "user-uuid-angela-walker",
  },
  {
    id: 28,
    title: "Brake Pad Replacement - Ram 1500 - VIN 1C6RR7GT5HS1...",
    name: "Brake Pad Replacement - Ram 1500 - VIN 1C6RR7GT5HS1...",
    owner: "Jason Hall",
    owner_full_name: "Jason Hall",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Syncing",
    tags: ["Brake Pad", "Replacement", "Ram", "Dodge"],
    document_uuid: "doc-uuid-28",
    description: "Brake pad replacement for Ram 1500",
    version: 1,
    scope: "replacement",
    summary: "Ram 1500 brake pad replacement",
    path: "/shared/brake_replacements/ram_1500_brake_pads",
    owner_uuid: "user-uuid-jason-hall",
  },
  {
    id: 29,
    title: "Spark Plug Analysis - F-150 5.0L V8 - VIN 1FTFW1ET5DFC...",
    name: "Spark Plug Analysis - F-150 5.0L V8 - VIN 1FTFW1ET5DFC...",
    owner: "Melissa Young",
    owner_full_name: "Melissa Young",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Connected Agent",
    tags: ["Spark Plug", "Analysis", "Ford", "V8"],
    document_uuid: "doc-uuid-29",
    description: "Spark plug analysis for F-150 5.0L V8",
    version: 1,
    scope: "analysis",
    summary: "F-150 5.0L V8 spark plug analysis",
    path: "/shared/spark_plug_analysis/f150_v8_spark_plugs",
    owner_uuid: "user-uuid-melissa-young",
  },
  {
    id: 30,
    title: "Timing Belt Inspection - Silverado 1500 - VIN 1GCVKREC8LZ1...",
    name: "Timing Belt Inspection - Silverado 1500 - VIN 1GCVKREC8LZ1...",
    owner: "Andrew King",
    owner_full_name: "Andrew King",
    date: "2025-10-01T15:00:00Z",
    created_at: "2025-10-01T15:00:00Z",
    updated_at: "2025-10-01T15:00:00Z",
    status: "Expired",
    tags: ["Timing Belt", "Inspection", "GM", "Silverado"],
    document_uuid: "doc-uuid-30",
    description: "Timing belt inspection for Silverado 1500",
    version: 1,
    scope: "inspection",
    summary: "Silverado 1500 timing belt inspection",
    path: "/shared/timing_belt_inspections/silverado_1500_timing",
    owner_uuid: "user-uuid-andrew-king",
  },
];
